<template>
  <div
    v-if="isPdfPage"
    :class="$style.content"
  >
    <slot />
  </div>

  <layout-base
    v-else
    :class="$style.navigation"
  >
    <div
      v-if="isViewSidebar"
      :class="$style.sidebar"
    >
      <div @click="toggle">
        <img
          src="@/assets/images/icons/navigation/big-arrow.svg"
          :class="$style.arrow"
        >
      </div>

      <div
        :class="$style.sidebarItem"
        :title="$t('global.logout')"
        @click="logout"
      >
        <img src="@/assets/images/icons/logout.svg">
      </div>
      <switch-locale :class="$style.sidebarLocal" />
    </div>
    <block-navigation
      v-else
      :is-view-sidebar="isViewSidebar"
      @logout="logout"
      @toggle="toggle"
    />
    <div :class="$style.content">
      <loader
        v-show="isLoaderNeeded"
        :class="$style.loader"
      />
      <slot />
    </div>
  </layout-base>
</template>

<script>
  import LayoutBase from '@/layouts/base.vue';
  import BlockNavigation from '@/components/layouts/navigation/block-navigation.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import SwitchLocale from '@/components/common/locale/locale.vue';

  export default {
    components: {
      LayoutBase,
      BlockNavigation,
      Loader,
      SwitchLocale,
    },
    data: () => ({
      isViewSidebar: false,
    }),
    computed: {
      isLoaderNeeded() {
        return this.$store.getters['loader/isLoaderNeeded'];
      },
      isPdfPage() {
        return this.$route.query.pdf === 'true';
      },
    },
    methods: {
      toggle() {
        this.isViewSidebar = !this.isViewSidebar;
      },
      logout() {
        return this.$store.dispatch('user/logout').then(() => this.$router.push({ name: 'user-login' }));
      },
    },
  };
</script>

<style lang="scss" module>
  .navigation {
    gap: 20px;
  }

  .sidebar {
    background: $white;
    padding-top: 23px;
    min-width: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin: 20px 0;
  }

  .sidebarItem {
    cursor: pointer;

    img {
      margin: 0 auto;
      display: block;
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    background: white;
    z-index: 50000;
  }

  .content {
    margin-top: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    flex-grow: 1;
    // display: inline-flex;
    display: flex;
    max-width: calc(100% - 30px);
    position: relative;
  }

  .sidebarLocal {
    display: flex;
    flex-direction: column;
  }

  .arrow {
    cursor: pointer;
    display: inline-flex;
    transform: rotate(-90deg);
  }
</style>
